<template>
    <div class="headerNovelty">
      <h1>{{ $t('novelties.label.list.title') }}</h1>
      <v-data-table 
        :headers="headers" 
        :items="novelties.items" 
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>
  
              <div class="btn" v-if="!novelties.isMax">
                <addNovelties />
              </div>
            </div>
          </div>
        </template>
        
        <template v-slot:[`item.title`]="{ item }">
          <span class="custom-font">{{ item.title }}</span>
        </template>
  
        <template v-slot:[`item.functionality`]="{ item }">
          <span class="custom-font">{{ item.functionality }}</span>
        </template>
  
        <template v-slot:[`item.startDate`]="{ item }">
          <span class="custom-font">{{ item.startDate }}</span>
        </template>
  
        <template v-slot:[`item.endDate`]="{ item }">
          <span class="custom-font">{{ item.endDate }}</span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <span class="custom-font">{{ item.status == true ? $t('novelties.label.status.option1') : $t('novelties.label.status.option2') }}</span>
        </template>
  
        <template v-slot:[`item.action`]="{ item }">
          <!-- Botón de acción para abrir el diálogo de detalles  -->
          <v-icon
            color="primary"
            size="x-large"
          ></v-icon>
          
          <div class="actions">
  
            <detailsNovelties :noveltyProps="item" style="margin-left:1vh">
              <v-btn
                icon    
                x-large
                dark
                text
                >             
                <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
            </detailsNovelties>

            <v-btn
              class="btnDetails"
              icon    
              x-large
              dark
              text
              @click = "deleteNovelty(item.newsUpdateId)"
              style="background-color: transparent; margin-left:1vh"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
  
      </v-data-table>
  
    </div>
  </template>
  
  <script>
  import addNovelties from "@/views/novelties/pages/add_novelties/add_novelties_page.vue";
  import detailsNovelties from "@/views/novelties/pages/detail_novelties/detail_novelty_page.vue";
  import  EventBus  from '@/utils/event_bus.js'; 
  import { mapActions, mapGetters } from "vuex";
  import i18n from '@/plugins/i18n';
  import Swal from "sweetalert2";
  
  import {
    ACTION_DELETE_NOVELTIES,
    ACTION_GET_NOVELTIES,
    GET_NOVELTIES,
    NOVELTIES_M,
  } from "@/views/novelties/store/types/types.js";
  
  export default {
    name: "listNoveltiesComponent",
    components: {
      addNovelties,
      detailsNovelties
    },
  
    data() {
      return {
        searchTerm: "",
      };
    },
  
    async mounted() {
      await this.getActionNovelties();
      
      EventBus.$on('reload-novelties', async () => {
        await this.reloadNovelties();
      });
  
      EventBus.$on('formNovelties-submitted-successfully', async () => {
        await this.reloadNovelties();
      });

      EventBus.$on('reload-update-novelties', async () => {
        await this.reloadNovelties();
      });      
      
      EventBus.$on('reload-delete-novelties', async () => {
        await this.reloadNovelties();
      });

    },
  
    methods: {
  
      ...mapActions({
        getActionNovelties: `${NOVELTIES_M}${ACTION_GET_NOVELTIES}`,
        deleteActionNovelties: `${NOVELTIES_M}${ACTION_DELETE_NOVELTIES}`,
      }),
  
      async reloadNovelties() {
        await this.getActionNovelties();
      },
  
      search() {
        // Actualiza el término de búsqueda
        this.searchTerm = event.target.value;
      },
  
      async deleteNovelty(newsUpdateId) {
          const result = await Swal.fire({
            title: i18n.t('label.delete.title'),
            text: i18n.t('label.delete.text'),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: i18n.t('button.delete.accept'),
            cancelButtonText: i18n.t('button.delete.cancel'),
            confirmButtonColor: "#6E17A5"
          });
  
          if (result.isConfirmed) {
            await this.deleteActionNovelties(newsUpdateId);
            this.getActionNovelties()
            await this.reloadNovelties();
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: i18n.t('label.delete.cancel'),
              showConfirmButton: false,
              timer: 2500
            }); 
          }
      },
  
    },
  
    computed: {
  
      ...mapGetters({
        novelties: [`${NOVELTIES_M}${GET_NOVELTIES}`],
      }),
  
      headers() {
        return [
          {
            text: this.$t('novelties.label.table.title'),
            value: "title",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('novelties.label.table.functionality'),
            value: "functionality",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('novelties.label.table.startDate'),
            value: "startDate",
            sortable: false,
            align: "center",
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('novelties.label.table.endDate'),
            value: "endDate",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            text: this.$t('novelties.label.table.status'),
            value: "status",
            align: "center",
            sortable: false,
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            //text: "Acciones",
            value: "action",  // Cambiado de 'action' a 'actions'
            sortable: false,
            align: "center",
            //class: "primary--text custom-header mdi-pencil text-subtitle-1",
          },
        ];
      }, 
    },
    
  };
  </script>
  
  <style lang="css" scoped>
  
    .headerNovelty h1 {
      margin-bottom: 30px;
    }
  
    .headerNovelty {
      display: flex;
      gap: 40px;
      flex-direction: column;
      margin-top: 20px;
      margin-left: 20px;
    }
  
    .actions v-icon {
      font-size: 24px;
    }
    .custom-font {
      font-size: 20px;
    }
    /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
    body {
      font-family: "Nunito Sans", sans-serif;
    }
    
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Amsi Pro", sans-serif;
      color: #2d0049;
      font-weight: normal;
    }
  /* Estilos para el botón de eliminar */
    .btnDetails .v-icon {
      color: #6E17A5;
      margin-bottom: 19px;
    }
  
    /**estilo de los iconos */
    .actions{
      display:flex;
         
    }

    /* .marginIcon{
      margin-top: 12;
    } */
  
    img{
      width: 3rem;
      height: 3rem;
    }
  
    @media screen and (max-width: 414px) {
          
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          .custom-font{
            font-size: 13px;
          }
          img{
            margin-top: 18px;
            margin-bottom: auto;
            width: 3rem;
            height: 3rem;
          }
      }
  
      @media screen and (min-width: 414px) {
          
          h1{
              font-size:4vh;
              margin-left:2vh
          }
        
      }
   
      @media screen and (max-width: 280px) { 
  
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          h2{
              font-size:2vh;
          }
          .custom-font{
            font-size: 13px
          }
          img{
            margin-top: 20px;
            margin-bottom: 10px;
            width: 3rem;
            height: 3rem;
          }
      } 
  
  </style>
  